import {h, Component} from 'preact';
import {PageContent, CallRepairsLink, EquipmentResultItem} from '../components';
import Search from '@components/search';
import {
    EquipmentListHeader,
    EquipmentListEmpty
} from '../Equipment';
import {box} from '@containers/SmsPortal/styles';

const ContactServiceRepairs = () => (
    <div className={`mt-16 ${box.info}`}>
        If are unable to find your equipment by serial number, please call
        our customer service team to help initiate a repair
        at <CallRepairsLink />
    </div>
);

const ResultItemRenderer = ( item, index ) => <EquipmentResultItem key={item.serialId} {...item} />;

export class EquipmentList extends Component {

    static defaultProps = {
        equipmentList: []
    };

    enableSearchAtCount = 21;
    maxResultCount = 10;
    state = {
        addressFilter: 'all'
    };

    constructor ( props ) {
        super( props );
        this.onAddressChange = this.onAddressChange.bind( this );
    }

    onAddressChange ( e ) {
        const addressFilter = e.target.value;
        this.setState( {addressFilter} );
    }

    render () {
        const {
            equipmentList,
            addressList,
            error
        } = this.props;

        const {addressFilter} = this.state;
        let filter = null;

        if ( addressFilter !== 'all' ) {
            filter = ( item ) => item.placeId === addressFilter
        }

        if ( !equipmentList || equipmentList.length <= 0 ) {
            return <EquipmentListEmpty/>;
        }

        const queryGroup = {
            list: equipmentList,
            queryProps: ['serialId', 'itemName', 'modelId', 'lotId'],
            renderer: ResultItemRenderer,
            filter
        };

        if ( equipmentList.length > this.enableSearchAtCount ) {
            return (
                <PageContent>
                    <div className="mt-4">
                        <Search
                            showPagination={true}
                            alwaysShowResults={true}
                            resultLimit={this.maxResultCount}
                            queryGroup={[queryGroup]}>
                            {searchProps =>
                                <div>
                                    <div className="md:flex w-full lg:flex-1">
                                        <div>
                                            <label htmlFor="equipmentFilter">Filter by product name, lot#, model</label>
                                            <Search.Input id="equipmentFilter"
                                                          placeholder="e.g. C5123D; VALO Cordless;"/>
                                            <div className="mt-1 block text-xs md:text-sm txt-c2">
                                                Filter your equipment list by serial number, product name or SKU.
                                            </div>
                                        </div>
                                        <div className="mt-4 md:mt-0 md:ml-8">
                                            <label htmlFor="placeId">Filter by office address</label> <select
                                            name="placeId" id="placeId"
                                            className="overflow-hidden max-w-full"
                                            onChange={this.onAddressChange}>
                                            <option value="all">All locations</option>
                                            {addressList.map( addr =>
                                                <option selected={addressFilter === addr.placeId}
                                                        value={addr.placeId}>
                                                    {`${addr.address1} ${addr.city} ${addr.state}`}
                                                </option> )}
                                        </select>
                                        </div>
                                    </div>

                                    <Search.Results>
                                        {results =>
                                            <div className="my-6">
                                                <EquipmentListHeader/> {results} {results.children &&
                                            results.children.length <=
                                            0 &&
                                            <div className="px-2 max-w-md">
                                                <p>Your search did not match any items in your equipment list.</p>
                                                <p className="mt-4">Suggestions:</p>
                                                <ul className="bullets leading-tight">
                                                    <li>Use a serial number or product name for keywords e.g. "C5123D"
                                                        or "VALO"
                                                    </li>
                                                    <li>Search from all locations by removing any location filters</li>
                                                    <li>Try using fewer keyword</li>
                                                    <li>Make sure all words are spelled correctly</li>
                                                </ul>
                                            </div>
                                            }
                                            </div>
                                        }
                                    </Search.Results>
                                </div>
                            }
                        </Search>
                    </div>
                    <ContactServiceRepairs />
                </PageContent>
            );
        }

        return (
            <PageContent>
                <div className="mt-4">
                    <div className="py-4">{equipmentList.map( ResultItemRenderer )}</div>
                </div>
                <ContactServiceRepairs />
            </PageContent>
        );

    }
}
